import type { Stack } from '../../../api/crashes'

/** A report's stack, innermost frame first, with each frame's inlined calls. */
export function StackTable({ stack }: { stack: Stack }) {
	if (!stack.frames.length) return <p className="muted small">No attributed frames.</p>
	return (
		<div className="table-scroll">
			<table>
				<thead>
					<tr>
						<th>Binary</th>
						<th>Offset</th>
						<th>Function / source (including inlines)</th>
					</tr>
				</thead>
				<tbody>
					{stack.frames.map((frame, index) => (
						<tr key={index}>
							<td>
								{frame.binaryName}
								<div className="muted small mono">{frame.binaryUUID}</div>
							</td>
							<td className="mono">+{frame.offset}</td>
							<td>
								{frame.inlines.length ? (
									frame.inlines.map((location, i) => (
										<div key={i}>
											<span className="mono">{location.function}</span>
											{location.file && (
												<div className="muted small">
													{location.file}:{location.line ?? '?'}
												</div>
											)}
										</div>
									))
								) : (
									<span className={frame.function ? 'mono' : 'muted'}>{frame.function ?? 'Unresolved'}</span>
								)}
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	)
}
